<template>

  <button
    type="button"
    class="btn btn-light"
    :class="{'box-loading': loading}"
    @click="follow(following?'unfollow':'follow')">
    <i class="fas fa-rss" :class="{'text-success': following, 'text-secondary': !following}" />
    {{ following ? $t('Following') : $t('Follow') }}
    </button>

</template>

<script>
export default {
  name: 'JobFolow',
  components: {
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    me () {
      return this.$store.getters.getMe
    },
    following () {
      return this.job.followers.find((val) => {
        return val === this.me._id
      })
    }
  },
  created () {
  },
  methods: {
    follow (action) {
      this.loading = true
      this.$store
      .dispatch('followJob', {
        job_id: this.job._id,
        action: action
      })
      .then((result) => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobHeader/JobFollow.vue